const getProperCoordinateType = (mappable) => {
  const { coordinates } = mappable;
  const coordinatesExist = !!coordinates;
  const coordinatesIsArray = coordinates.length !== undefined;
  const coordsIsNaN = (coords) => {
    const parsedLat = parseFloat(coords.lat);
    const parsedLon = parseFloat(coords.lng);
    const nanLat = isNaN(parsedLat);
    const nanLon = isNaN(parsedLon);
    return nanLat || nanLon;
  };
  const getHasInvalidEntries = coordinatesIsArray
    ? () => coordinates.some(coordsIsNaN)
    : () => coordsIsNaN(coordinates);

  if (!coordinatesExist || getHasInvalidEntries()) {
    return false;
  }
  return coordinatesIsArray ? coordinates : [coordinates];
};

export default getProperCoordinateType;
